import * as React from 'react'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import * as st from './customerErrorMessage.module.scss'

export interface IErrorMessageProps {
  stringId: StringId
}

export const CustomerErrorMessage = ({ stringId }: IErrorMessageProps) => {
  return (
    <div className={st.fatalErrorMessage}>
      <TextLocalizer stringID={stringId} />
    </div>
  )
}